<template>
  <div class="col-md-12">
    <div class="card">
      <div class="card-header">
        <h4 class="card-title">{{ title }}</h4>
      </div>
      <div class="card-body">
        <div class="row form">
          <div class="col-12 col-sm-6">
            <div class="form-group">
              <label for="addAsset_make">Make</label>
              <input type="text" name="Make" class="form-control" id="addAsset_make" placeholder="" v-model="tractor.make" v-validate="'required'" :disabled="readonly">
            </div>
            <div class="form-group">
              <label for="addAsset_model">Model</label>
              <input type="text" name="Model" class="form-control" id="addAsset_model" placeholder="" v-model="tractor.model" v-validate="'required'" :disabled="readonly">
            </div>
            <div class="form-group">
              <label for="addAsset_ID">Asset ID</label>
              <input type="text" class="form-control" id="addAsset_ID" placeholder="" v-model="tractor.assetId" :disabled="readonly">
            </div>
            <div class="form-group">
              <label for="addAsset_tractortype">Tractor Type</label>
              <select id="addAsset_tractortype" class="form-control" v-model="tractor.tractorType" :disabled="readonly">
                <option value="TractorOnly">Tractor Only</option>
                <option value="StraightTruck" selected>Straight Truck</option>
              </select>
            </div>
          </div>
          <div class="col-12 col-sm-6">
            <div class="form-group">
              <label for="addAsset_engine">Engine Type</label>
              <input type="text" name="Engine Type" class="form-control" id="addAsset_engine" placeholder="" v-model="tractor.engineType" v-validate="'required'" :disabled="readonly">
            </div>
            <div class="form-group">
              <label for="addAsset_emissions">Emissions Profile</label>
              <div class="input-group">
                <input type="number" min="0" name="Emissions Profile" class="form-control" id="addAsset_emissions" placeholder="" v-model="tractor.emissionsProfile" v-validate="'required|min_value:0'" :disabled="readonly"/>
                <span class="input-group-addon su-group-addon">g CO2 per ton-mile</span>
              </div>
            </div>
            <div class="form-group">
              <label for="addAsset_telematics">Telematics ID</label>
              <input type="text" class="form-control" id="addAsset_telematics" placeholder="" v-model="tractor.telematicsId" :disabled="readonly">
            </div>
            <div class="form-group">
              <label for="addAsset_GIAI">GIAI</label>
              <input type="text" class="form-control" id="addAsset_GIAI" placeholder="" v-model="tractor.giai" :disabled="readonly">
            </div>
          </div>
        </div>
        <div v-if="isStraightTruck">
          <hr>
          <h4 class="card-title mb-3">Straight Truck Details</h4>
          <div class="row form"> <!-- Only if Straight Truck -->
            <div class="col-12 col-sm-6">
              <div class="form-group">
                <label for="addAsset_techprovider">Tech Provider</label>
                <select id="addAsset_techprovider" class="form-control" v-model="tractor.st.techProvider" :disabled="readonly">
                  <option value=""></option>
                  <option value="dummyTracker">Dummy Tracker</option>
                  <option value="bluerover">BlueRover</option>
                </select>
              </div>
              <div class="form-group">
                <label for="addAsset_techproviderID">Tech Provider ID</label>
                <input type="text" class="form-control" id="addAsset_techproviderID" placeholder="" v-model="tractor.st.techProviderId" :disabled="readonly">
              </div>
              <div class="form-group">
                <label for="addAsset_trailertype">Trailer Type</label>
                <select id="addAsset_trailertype" class="form-control" v-model="tractor.st.trailerType" :disabled="readonly">
                  <option value=""></option>
                  <option value="DryVan">Dry Van</option>
                  <option value="Flatbed">Flatbed</option>
                  <option value="ContainerChassis">Container Chassis</option>
                </select>
              </div>
              <div class="form-group">
                <label for="addAsset_length">Length</label>
                <input type="text" name="Length" class="form-control" id="addAsset_length" placeholder="" v-model="tractor.st.length" v-validate="'required'" :disabled="readonly">
              </div>
              <div class="form-group">
                <label for="addAsset_liftgate">Lift Gate</label>
                <select id="addAsset_liftgate" name="Lift Gate" class="form-control" v-model="tractor.st.liftGate" v-validate="'required'" :disabled="readonly">
                  <option value="Yes">Yes</option>
                  <option value="No">No</option>
                </select>
              </div>
              <div class="form-group">
                <label for="addAsset_suspension">Suspension Type</label>
                <select id="addAsset_suspension" class="form-control" v-model="tractor.st.suspension" :disabled="readonly">
                  <option value=""></option>
                  <option value="Spring">Spring</option>
                  <option value="Air">Air</option>
                </select>
              </div>
            </div>
            <div class="col-12 col-sm-6">
              <div class="form-group">
                <label for="addAsset_refrigeration">Refrigeration Unit</label>
                <select id="addAsset_refrigeration" name="Refrigeration Unit" class="form-control" v-model="tractor.st.refrigerationUnit" v-validate="'required'" :disabled="readonly">
                  <option value="Yes">Yes</option>
                  <option value="No">No</option>
                </select>
              </div>
              <div class="card bg-white mb-3"> <!-- only if Refrigeration Unit is "yes" -->
                <div class="card-body">
                  <h5 class="card-title">Refrigeration Unit Details</h5>
                  <hr>
                  <div class="form-group">
                    <label for="addAsset_techproviderID">Make</label>
                    <input type="text" name="refrigeration unit's Make" class="form-control" id="addAsset_techproviderID" placeholder="" :disabled="!hasRefrigerationUnit || readonly" v-model="tractor.ru.make" v-validate="'required'">
                  </div>
                  <div class="form-group">
                    <label for="addAsset_techproviderID">Model</label>
                    <input type="text" name="refrigeration unit's Model" class="form-control" id="addAsset_techproviderID" placeholder="" :disabled="!hasRefrigerationUnit || readonly" v-model="tractor.ru.model" v-validate="'required'">
                  </div>
                  <div class="form-group">
                    <label for="addAsset_techproviderID">Engine Type</label>
                    <input type="text" name="refrigeration unit's Engine Type" class="form-control" id="addAsset_techproviderID" placeholder="" :disabled="!hasRefrigerationUnit || readonly" v-model="tractor.ru.engineType" v-validate="'required'">
                  </div>
                  <div class="form-group">
                    <label for="addAsset_techproviderID">Emissions Profile</label>
                    <div class="input-group">
                      <input type="number" min="0" name="refrigeration unit's Emissions Profile" class="form-control" id="addAsset_techproviderID" placeholder="" :disabled="!hasRefrigerationUnit || readonly" v-model="tractor.ru.emissionsProfile" v-validate="'required|min_value:0'">
                      <span class="input-group-addon su-group-addon">g CO2 per ton-mile</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'TractorForm',
  props: ['title', 'asset', 'readonly'],
  data: () => ({
    tractor: {
      make: '',
      model: '',
      assetId: '',
      engineType: '',
      emissionsProfile: '',
      telematicsId: '',
      giai: '',
      tractorType: 'TractorOnly',
      // straight truck data
      st: {
        techProvider: '',
        techProviderId: '',
        trailerType: 'DryVan',
        length: '',
        liftGate: 'No',
        suspension: 'Spring',
        refrigerationUnit: 'No'
      },
      // refrigeration unit data
      ru: {
        make: '',
        model: '',
        engineType: '',
        emissionsProfile: ''
      }
    }
  }),
  computed: {
    isStraightTruck: function() { 
      return this.tractor.tractorType === 'StraightTruck';
    },
    hasRefrigerationUnit: function() {
      return this.tractor.st.refrigerationUnit === 'Yes';
    }
  },
  mounted () {
  }, // end mounted
  methods: {
    getClearData: function() {
      let data = Object.assign({
        type: "Tractor"
      }, this.tractor);
      delete data.st;
      delete data.ru;

      if(this.isStraightTruck) {
        data = Object.assign(data, this.tractor.st);
        delete data.refrigerationUnit;
        data.liftGate = data.liftGate === "Yes";
      }
      if(this.hasRefrigerationUnit) data.ru = Object.assign({}, this.tractor.ru);
      return data;
    },
    loadData: function(data){
      if(!data) return;

      this.tractor.make = data.make || '';
      this.tractor.model = data.model || '';
      this.tractor.assetId = data.assetId || '';
      this.tractor.engineType = data.engineType || '';
      this.tractor.emissionsProfile = data.emissionsProfile || '';
      this.tractor.telematicsId = data.telematicsId || '';
      this.tractor.giai = data.giai || '';
      this.tractor.tractorType = data.tractorType || 'TractorOnly';

      this.tractor.st.techProvider = data.techProvider || '';
      this.tractor.st.techProviderId = data.techProviderId || '';
      this.tractor.st.trailerType = data.trailerType || 'DryVan';
      this.tractor.st.length = data.length || '';
      this.tractor.st.liftGate = data.liftGate ? 'Yes' : 'No';
      this.tractor.st.suspension = data.suspension || 'Spring';
      this.tractor.st.refrigerationUnit = data.ru ? 'Yes' : 'No';

      if(!data.ru) return;
      this.tractor.ru.make = data.ru.make || '';
      this.tractor.ru.model = data.ru.model || '';
      this.tractor.ru.engineType = data.ru.engineType || '';
      this.tractor.ru.emissionsProfile = data.ru.emissionsProfile || '';
    }
  }
}
</script>

<style scoped>
.su-group-addon {
  background-color: #eee !important; 
  border: 1px solid #ccc !important;
}
</style>


// WEBPACK FOOTER //
// TractorForm.vue?ea1b59da